/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

const ROLES_BASE_LINK = '/admin/roles'

export function getRoleCreateLink () {
  return `${ROLES_BASE_LINK}/create`
}

export function getRoleLink (id: number) {
  return `${ROLES_BASE_LINK}/${id}/edit`
}

export function getRoleListLink () {
  return ROLES_BASE_LINK
}
